module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('div', {
    staticClass: "container-fluid full-height"
  }, [_c('div', {
    staticClass: "row full-height"
  }, [_c('v-app', [_c('div', {
    staticClass: "col-md-8 full-height",
    attrs: {
      "id": "mainChartArea"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 full-height optionsTab"
  }, [_c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "divLogo"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "id": "logo",
      "src": require("../assets/LCP_eXcYte_final.png"),
      "alt": "Responsive image"
    }
  })]), _vm._v(" "), _c('input-section', {
    attrs: {
      "headerClass": "header",
      "subheaderClass": "white sub-header"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 titles"
  }, [_c('summary-section', {
    attrs: {
      "headerClass": "header",
      "subheaderClass": "white sub-header",
      "toolbarClass": "white toolbar-no-shadow content-color"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 titles"
  }, [_c('box-tools', {
    attrs: {
      "styleClass": "header"
    }
  })], 1)], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307bb544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1277
// module chunks = 1